var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news-container app"},[_c('van-skeleton',{attrs:{"row":20,"loading":_vm.loading}},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.showInfo)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }